import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RedirectIfAuthenticated = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    if (isAuthenticated) {
        // redirect based on role so users land in the right area
        if (user?.is_admin) return <Navigate to="/admin" replace />;
        if (user?.is_doctor) return <Navigate to="/vet" replace />;
        if (user?.is_vendor) return <Navigate to="/vendor" replace />;
        if (user?.is_laboratory) return <Navigate to="/lab" replace />;

        // default for regular users
        return <Navigate to="/aqua-doc" replace />;
    }

    return children;
};

export default RedirectIfAuthenticated;